<template>
	<article class="table-container" :class="{ 'side-nav-layout': sideNavOverlay }">
		<slot />
	</article>
</template>

<script setup lang="ts">
defineProps<{
	// true when the SideNav floats over content instead of pushing it,
	// so .table-container must clear its rail itself instead of relying on .home-content's left offset
	sideNavOverlay?: boolean
}>()
</script>

<style scoped>
.table-container {
	--padding: var(--spacing-xl);
	height: 100%;
	margin-left: calc(
		var(--left-panel-open, 1) * (var(--width-left-panel) - var(--width-nav-expanded) + var(--current-nav-width))
	);
	padding: var(--padding);
	padding-right: calc(var(--padding) + var(--right-panel-open, 0) * var(--width-detail-panel));
	display: flex;
	flex-direction: column;
	background-color: var(--neutral-0);
	transition:
		margin-left 0.3s ease-in-out,
		padding-right 0.3s ease-in-out;

	&.side-nav-layout {
		margin-left: calc(var(--current-nav-width) + var(--left-panel-open, 0) * var(--width-left-panel));
	}
}
</style>
